module.exports = __webpack_public_path__ + "static/media/logo.cef6b9e0.png";